import { render, staticRenderFns } from "./ManagePropertyRolesModal.vue?vue&type=template&id=5f1ac9e6&"
import script from "./ManagePropertyRolesModal.vue?vue&type=script&lang=ts&"
export * from "./ManagePropertyRolesModal.vue?vue&type=script&lang=ts&"
import style0 from "./ManagePropertyRolesModal.vue?vue&type=style&index=0&id=5f1ac9e6&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports